import { bool, string } from 'prop-types';
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import HorizontalScroll from '@components/HorizontalScroll';

import useTrendResearchFilterParams from '@features/trend-research/hooks/useTrendResearchFilterParams';
import useKeyDesigns from '@features/trend-research/hooks/useTrendResearchKeyDesigns';
import EmptyState from '@features/trend-research/components/common/EmptyState';
import {
	Card,
	CardContent,
	PrintGraphicsImageContainer,
	TopBar
} from '@features/trend-research/components/common/TrendCard';

import { useInsightSummary } from '@store/reducers/trend-research/TrendResearchReducer';

import { processDecimalValue } from '@utils/Util';

const KeyGraphicsOrPrint = ({ isSummaryCountSet, title, keyType, summaryField, source, type }) => {
	const navigate = useNavigate();
	const summaryCounts = useInsightSummary();
	const scrollRef = useRef(null);
	const removeParamList =
		source === 'Instagram' ? ['fabricTypeList', 'brandCodeList'] : ['instagramUserNameList'];
	const { queryParams } = useTrendResearchFilterParams(removeParamList);

	const { designs, showHorizontalScroll } = useKeyDesigns(
		keyType,
		queryParams,
		summaryCounts,
		summaryField,
		isSummaryCountSet,
		scrollRef
	);

	const renderCards = () => {
		const handleRoute = (selectedItem) => {
			navigate(`/trends/details${queryParams}`, {
				state: {
					selectedItem,
					type,
					source
				}
			});
		};

		return designs?.map((item, idx) => {
			const [mainImage, ...images] = item?.imageUrlList || [];
			const contents = {
				title: item.graphicsName,
				itemCount: item.graphicsCount,
				percentage: summaryCounts?.noOfProducts
					? processDecimalValue((item.graphicsCount / summaryCounts.noOfProducts) * 100) + '%'
					: `0%`
			};

			return (
				<Card
					className="key-graphics-single cursor-pointer"
					key={`key_${keyType}_${idx}`}
					onClick={() =>
						handleRoute({ ...item, percentage: contents.percentage, isTop: idx === 0 })
					}
				>
					<TopBar topText={idx === 0} />
					<PrintGraphicsImageContainer mainImage={mainImage} images={images} />
					<CardContent details={contents} tooltipSize={42} />
				</Card>
			);
		});
	};

	return (
		<div className="key-graphics-section trend-padding scrollbar-on-hover">
			<div className="section-title pb-3 d-flex align-items-center justify-content-between">
				<p className="semibold-16 gray_dark_01 d-flex align-items-center">
					<img
						src={
							type === 'key-graphics'
								? process.env.PUBLIC_URL + '/icons/flag/key-grapics.svg'
								: process.env.PUBLIC_URL + '/icons/flag/key-prints.svg'
						}
						width={20}
					/>
					<span className="pl-1">{title}</span>
				</p>
			</div>
			{designs.length > 0 ? (
				<div className="d-flex scroll-x-label graphics-slider trending-slider" ref={scrollRef}>
					{showHorizontalScroll && <HorizontalScroll elementReference={scrollRef.current} />}
					{renderCards()}
				</div>
			) : (
				<EmptyState />
			)}
		</div>
	);
};

KeyGraphicsOrPrint.propTypes = {
	isSummaryCountSet: bool.isRequired,
	title: string.isRequired,
	source: string.isRequired,
	summaryField: string.isRequired,
	keyType: string.isRequired
};

export default KeyGraphicsOrPrint;
